/** Joins stored incident origins for display. Values are data, not chrome. */
export function formatIncidentOrigins(
  origin: readonly string[] | string | null | undefined,
): string {
  const values = Array.isArray(origin) ? origin : origin ? [origin] : [];
  const cleaned: string[] = [];

  for (const value of values) {
    const trimmed = value.trim();
    if (trimmed && !cleaned.includes(trimmed)) {
      cleaned.push(trimmed);
    }
  }

  return cleaned.join(', ');
}
